import { useEffect, useState } from 'react'
import { t } from 'i18next'
import { useLazyQuery } from '@apollo/client'
import { GET_ROUTE_TYPE } from 'graphql/route/queries'

export function RouteTypeDropdown({ fields, error, helperText, purpose }) {
    const [routeTypeList, setRouteTypeList] = useState(null)
    const [getRouteTypeList, { loading: typeListLoading, error: typeListError }] = useLazyQuery(GET_ROUTE_TYPE, {
        notifyOnNetworkStatusChange: true,
        onCompleted: data => {
            if (data.routeType?.length > 0) {
                setRouteTypeList(data.routeType)
            } else {
                setRouteTypeList([])
            }
        },
    })

    useEffect(() => {
        getRouteTypeList({ variables: { code: null } })
    }, [])

    if (typeListError) {
        return (
            <select>
                <option value={null}>{t('No data found')}</option>
            </select>
        )
    }

    if (!typeListLoading && routeTypeList?.length === 0) {
        return (
            <select>
                <option value={null}>{t('No data found')}</option>
            </select>
        )
    }

    return (
        <>
            {!typeListLoading && routeTypeList?.length > 0 && (
                <select
                    {...fields}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:max-w-xs sm:text-sm sm:leading-6"
                >
                    {purpose === 'filter' ? (
                        <option value={null}>{t('All')}</option>
                    ) : (
                        <option value="" disabled>
                            {t('Select Route Type')}
                        </option>
                    )}
                    {routeTypeList.map(type => (
                        <option key={type.code} value={type.code}>
                            {type.description.en}
                        </option>
                    ))}
                </select>
            )}
            {error && <p className="text-error text-xs mt-1">{helperText}</p>}
        </>
    )
}

